import type { Address } from "@jti/fe-common";
import type { MagentoOrderShippingMethod, MagentoPrice } from "@jti/magento-types";

import type { IOrderAttributeOutput, OrderDetailsTax } from "../types";

import type { OrderPrices } from "./OrderPrices";
import type { Product } from "./Product";

export type OrderItem = {
  item_id?: string;
  productSalePrice?: MagentoPrice;
  productSalePriceInclTax?: MagentoPrice;
} & Pick<
  Product,
  | "bundle_options"
  | "categories"
  | "color_label"
  | "flavor"
  | "id"
  | "imageUrl"
  | "isGift"
  | "name"
  | "price"
  | "price_range"
  | "product_type"
  | "quantity"
  | "sku"
  | "subscription"
  | "subscription_format"
  | "subtitle"
  | "type_id"
  | "parentGiftSku"
  | "tradeIn"
  | "nicotineStrength"
>;

export type Order = {
  orderId: string;
  number: string;
  isZeroValueOrder: boolean;
  methodAndCarrierCode: string;
  shippingMethod: MagentoOrderShippingMethod;
  shippingAddress: Address | null;
  status: string;
  billingAddress: Address | null;
  orderDate: string;
  paymentMethod: string;
  total: {
    taxes: OrderDetailsTax[];
    total_shipping: MagentoPrice;
  };
  total_after_trial: {
    total: MagentoPrice;
    total_incl_tax: MagentoPrice;
    tax: MagentoPrice;
  };
  total_including_trial?: {
    total: MagentoPrice;
    total_incl_tax: MagentoPrice;
    tax: MagentoPrice;
  };
  prices?: OrderPrices;
  additional_attributes?: IOrderAttributeOutput[];
  items?: OrderItem[];
};

export const OrderStatus = {
  new: "New",
  processing: "Processing",
  confirmed: "Confirmed",
  pending_payment: "Pending Payment",
  payment_failed: "Payment failed",
  payment_completed: "Payment completed",
  shipped: "Shipped",
  shipped_to_warehouse: "Shipped to warehouse",
  delivered: "Delivered",
  on_hold: "On Hold",
  delivered_to_pick_up_point: "Delivered To Pickup Point",
  pending: "Pending",
  pending_cancellation: "Pending cancellation",
  canceled: "Canceled",
  returned: "Returned",
  complete: "Complete",
};
